import { Locales } from '@calendly/i18n'
import moment from 'moment-timezone'

const mainLocales = new Locales({
  de: () => import(/* webpackChunkName: "locales/de" */'locales/de.locale'),
  en: () => import(/* webpackChunkName: "locales/en" */'locales/en.locale'),
  es: () => import(/* webpackChunkName: "locales/es" */'locales/es.locale'),
  fr: () => import(/* webpackChunkName: "locales/fr" */'locales/fr.locale'),
  it: () => import(/* webpackChunkName: "locales/it" */'locales/it.locale'),
  nl: () => import(/* webpackChunkName: "locales/nl" */'locales/nl.locale'),
  uk: () => import(/* webpackChunkName: "locales/nl" */'locales/uk.locale'),
  ps: () => import(/* webpackChunkName: "locales/ps" */'locales/ps.locale'),
  pt: () => import(/* webpackChunkName: "locales/pt" */'locales/pt.locale'),
})

const momentLocales = {
  de: () => import(/* webpackChunkName: "moment/locale/de" */'moment/locale/de'),
  en: () => Promise.resolve({}), // en locale is baked into moment itself
  es: () => import(/* webpackChunkName: "moment/locale/es" */'moment/locale/es'),
  fr: () => import(/* webpackChunkName: "moment/locale/fr" */'moment/locale/fr'),
  it: () => import(/* webpackChunkName: "moment/locale/it" */'moment/locale/it'),
  nl: () => import(/* webpackChunkName: "moment/locale/nl" */'moment/locale/nl'),
  uk: () => import(/* webpackChunkName: "moment/locale/nl" */'moment/locale/uk'),
  ps: () => import(/* webpackChunkName: "moment/locale/ps" */'moment/locale/x-pseudo'),
  pt: () => import(/* webpackChunkName: "moment/locale/pt" */'moment/locale/pt'),
}

const loadMomentLocales = async (locales) => {
  // loading an additional locale makes it current
  // so we have to remember the original locale
  // and switch back to it after the loading is done
  const originalLocale = moment.locale()

  await Promise.all(locales.map((locale) => momentLocales[locale]()))

  moment.locale(originalLocale)
}

export const loadLocale = async (...locales) => {
  const normalizedLocales = locales.flat().filter(Boolean)

  await Promise.all([
    mainLocales.load(normalizedLocales),
    loadMomentLocales(normalizedLocales)
  ])
}
